const getLocalePrefix = () => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  const firstSegment = pathSegments[0] ?? '';
  return /^[a-z]{2}$/i.test(firstSegment) ? `/${firstSegment}` : '';
};

export default getLocalePrefix;
